(function () {
    if (location.pathname !== '/products/best-sellers-collection') return;

    const params = new URLSearchParams(location.search);
    const purchaseParam = (params.get('purchase') || '').toLowerCase();
    if (purchaseParam !== 'subscribe') return;

    let done = false;

    function tryClick() {
        if (done) return true;
        const el = document.getElementById('subscribe-radio');
        if (!el) return false;
        el.click();
        done = true;
        return true;
    }

    let attempts = 0;
    const iv = setInterval(() => {
        attempts++;
        if (tryClick() || attempts >= 20) clearInterval(iv);
    }, 2500);
})();
